export default "__VITE_ASSET__BliInpZ0__"